import { AppHttpClient } from '../core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../core/http/app-http-client.service";
var ArtisanService = /** @class */ (function () {
    function ArtisanService(http) {
        this.http = http;
    }
    ArtisanService.prototype.call = function (payload) {
        return this.http.post('artisan/call', payload);
    };
    ArtisanService.ngInjectableDef = i0.defineInjectable({ factory: function ArtisanService_Factory() { return new ArtisanService(i0.inject(i1.AppHttpClient)); }, token: ArtisanService, providedIn: "root" });
    return ArtisanService;
}());
export { ArtisanService };
